import api from './api';

export interface AuthoritativeDataSource {
  _id: string;
  name: string;
  sourceType: 'Portal' | 'API' | 'Report' | 'Database' | 'Registry' | 'Other';
  url?: string;
  description?: string;
  owner?: string;
  order: number;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateAuthoritativeDataSource {
  name: string;
  sourceType: 'Portal' | 'API' | 'Report' | 'Database' | 'Registry' | 'Other';
  url?: string;
  description?: string;
  owner?: string;
  order?: number;
  isActive?: boolean;
}

export interface UpdateAuthoritativeDataSource extends Partial<CreateAuthoritativeDataSource> {}

const base = '/authoritative-data-sources';

const authoritativeDataSourcesService = {
  async list(q?: string): Promise<AuthoritativeDataSource[]> {
    const res = await api.get(`${base}`, { params: q ? { q } : undefined });
    return res.data.data as AuthoritativeDataSource[];
  },
  async create(payload: CreateAuthoritativeDataSource): Promise<AuthoritativeDataSource> {
    const res = await api.post(`${base}`, payload);
    return res.data.data as AuthoritativeDataSource;
  },
  async update(id: string, payload: UpdateAuthoritativeDataSource): Promise<AuthoritativeDataSource> {
    const res = await api.put(`${base}/${id}`, payload);
    return res.data.data as AuthoritativeDataSource;
  },
  async remove(id: string): Promise<void> {
    await api.delete(`${base}/${id}`);
  },
};

export default authoritativeDataSourcesService;
